<template>
  <div id="rateassist-details-t">
    <div class="row">
      <div class="col-xs-12" v-if="init">
        <div class="shadow clearfix">
          <hr class="hr-text" data-content="Details"/>
          <div class="col-xs-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label class="form-label">Origin Location</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Origin Location"
                placeHolder="Type to search"
                :initVal="entity.originLocation"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="l => selectLocation(l, 'originLocation')"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label class="form-label">Destination Location</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Destination Location"
                placeHolder="Type to search"
                :initVal="entity.destinationLocation"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="l => selectLocation(l, 'destinationLocation')"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label class="form-label">On Carriage Location</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="On Carriage Location"
                placeHolder="Type to search"
                :initVal="entity.onCarriageLocation"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="l => selectLocation(l, 'onCarriageLocation')"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label class="form-label">Pre Carriage Location</label>
              <autocomplete
                :dataset="locationSearchResults"
                title="Pre Carriage Location"
                placeHolder="Type to search"
                :initVal="entity.preCarriageLocation"
                v-on:changing="data => locationSearchText = data"
                :fnFormatText="displayLocation"
                :fnSelectValue="displayLocation"
                v-on:selection-made="l => selectLocation(l, 'preCarriageLocation')"
              ></autocomplete>
            </div>
            <div class="form-group">
              <label class="form-label" for="ct">Container Type</label>
              <select v-model="entity.containerType" id="ct" class="form-control">
                <option value=""></option>
                <option v-for="(opt, i) in containers" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label" for="wl">Wood Loose</label>
              <select v-model="entity.woodLoose" id="wl" class="form-control">
                <option value=""></option>
                <option v-for="(opt, i) in woodLooses" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="min" class="form-label">Is Minimum?</label>
              <div class="material-switch">
                <input id="min" type="checkbox" v-model="entity.minimumRate"/>
                <label for="min" class="label-success"></label>
              </div>
            </div>
            <div class="form-group">
              <label for="calcMin" class="form-label">Calculated Breakpoint Previous Band</label>
              <input type="number" id="calcMin" disabled class="form-control" v-model="entity.calculatedMinimum"/>
            </div>
            <div class="form-group">
              <label for="calcMax" class="form-label">Calculated Breakpoint Current Band</label>
              <input type="number" id="calcMax" disabled class="form-control" v-model="entity.calculatedMaximum"/>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 col-lg-4">
            <div class="form-group" v-for="field in numericalFields">
              <label :for="field" class="form-label">{{ deCamel(field) }}</label>
              <input type="number" :id="field" class="form-control" v-model="entity[field]"/>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 col-lg-4">
            <div class="form-group">
              <label for="routingInfo" class="form-label">Routing Info</label>
              <input id="routingInfo" class="form-control" v-model="entity.routingInfo"/>
            </div>
            <div class="form-group">
              <label for="placeOfDelivery" class="form-label">Place of Delivery</label>
              <input id="placeOfDelivery" class="form-control" v-model="entity.placeOfDelivery"/>
            </div>
            <div class="form-group">
              <label for="placeOfReceipt" class="form-label">Place of Receipt</label>
              <input id="placeOfReceipt" class="form-control" v-model="entity.placeOfReceipt"/>
            </div>
            <div class="form-group">
              <label for="portOfLoading" class="form-label">Port of Loading</label>
              <input id="portOfLoading" class="form-control" v-model="entity.portOfLoading"/>
            </div>
            <div class="form-group">
              <label for="portOfDischarge" class="form-label">Port of Discharge</label>
              <input id="portOfDischarge" class="form-control" v-model="entity.portOfDischarge"/>
            </div>
          </div>
          <div class="col-xs-12">
            <hr>
            <div class="pull-right">
              <div class="btn btn-success" @click="save">
                {{ saveOrUpdate }}
              </div>
              <div class="btn btn-danger" @click="doClear">
                Clear
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <vue-table
          v-if="!fetching"
          :maxItems="count"
          v-on:pages-remaining="$emit('loadMore')"
          v-on:page-back="$emit('loadBack')"
          :tableData="details"
          tableTitle="Lines"
          v-on:table-edit-request="updateActive"
          :showEdit="true"
          v-on:table-delete-request="doDelete"
          :showDelete="true"
          :showSelectAll="true"
          :allowSelect="true"
          v-on:select-all="deleteAll"
          v-on:filtering-or-sorting="getNewData"
          :countVisible="false"
          :usePages="true"
          :pageNumber="pageNumber"
          :fields="[
          { header: 'Container Type', prop: item => this.getOptionName(item.containerType) },
          { header: 'Wood Loose', prop: item => this.getOptionName(item.woodLoose) },
          { header: 'Pre Carriage', prop: item => item.preCarriageLocation ? item.preCarriageLocation.name : '' },
          { header: 'Pre Carriage Rate', prop: 'preCarriageRate', numericalField: true },
          { header: 'Origin', prop: item => item.originLocation ? item.originLocation.name : '' },
          { header: 'Destination', prop: item => item.destinationLocation ? item.destinationLocation.name : '' },
          { header: 'Rate', prop: 'lineRate', numericalField: true },
          { header: 'On Carriage', prop: item => item.onCarriageLocation ? item.onCarriageLocation.name : '' },
          { header: 'On Carriage Rate', prop: 'onCarriageRate', numericalField: true },
          { header: 'Min. Distance', prop: 'minimumDistance', numericalField: true },
          { header: 'Max. Distance', prop: 'maximumDistance', numericalField: true },
          { header: 'Min. Breakpoint', prop: 'minimumBreakpoint', numericalField: true },
          { header: 'Max. Breakpoint', prop: 'maximumBreakpoint', numericalField: true }
          ]"
        ></vue-table>
        <Loader v-else/>
      </div>
      <div class="col-xs-12">
        <div class="shadow clearfix">
          <blockquote>
            Mass Tariff Line Update
          </blockquote>
          <div class="line-download">
            <hr class="hr-text" data-content="Step 1 - First download the results shown above"/>
            <div class="text-center">
              <parse-from-json
                :json="detailsToSpreadsheet"
                :fileName="fileName"
                :disabled="false"
              >
              </parse-from-json>
            </div>
            <hr class="hr-text" data-content="Step 2 - Then upload your revisions"/>
            <div class="text-center">
              <parse-to-json
                v-on:parse-start="parsing"
                v-on:parse-complete="parsed"
              ></parse-to-json>
            </div>
            <hr>
          </div>
          <blockquote>
            Tariff Line Calculator
          </blockquote>
          <hr class="hr-text" data-content="Click below to updated Calculated values for the lines"/>
          <div class="text-center">
            <div class="btn btn-info sq" @click="doCalc">
              Calculate <i class="fa fa-calculator"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import LookupHelperMixin from '../../mixins/Helpers'
  import TransformMixin from '../../mixins/TransformMixin'
  import VueTable from '../../../helpers/VueTable.vue'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import ParseFromJson from '../../../helpers/ParseFromJson.vue'
  import ParseToJson from '../../../helpers/ParseToJson.vue'
  import CalculatedFieldsMixin from '../../../helpers/CalculatedFieldsMixin'
  import Loader from '../../../helpers/Loader'
  export default {
    name: 'TariffDetails',
    props: ['dets', 'lookup', 'count', 'pageNumber', 'fetching'],
    mixins: [ LookupHelperMixin, CalculatedFieldsMixin, TransformMixin ],
    components: {
      VueTable,
      Autocomplete,
      ParseFromJson,
      ParseToJson,
      Loader
    },
    data () {
      return {
        init: true,
        updateClicked: false,
        transformForUpdate: {
          originLocation: this.toMinus,
          destinationLocation: this.toMinus,
          woodLoose: this.toMinus,
          containerType: this.toMinus,
          minimumRate: this.toZero,
          journeyDistance: this.toZero,
          transitTime: this.toZero,
          lineRate: this.toZero,
          maximumCharge: this.toZero,
          maximumRate: this.toZero,
          minimumBreakpoint: this.toZero,
          maximumBreakpoint: this.toZero,
          minimumDistance: this.toZero,
          maximumDistance: this.toZero,
          onCarriageLocation: this.toMinus,
          onCarriageRate: this.toZero,
          preCarriageLocation: this.toMinus,
          preCarriageRate: this.toZero,
          calculatedMinimum: this.toZero,
          calculatedMaximum: this.toZero
        },
        dataForSpreadSheet: [],
        details: [],
        canEmit: true,
        numericalFields: ['journeyDistance', 'transitTime', 'lineRate', 'minimum', 'minimumBreakpoint', 'maximumBreakpoint', 'minimumDistance', 'maximumDistance', 'onCarriageRate', 'preCarriageRate', 'maximumCharge'],
        entity: {
          id: null,
          lookup: null,
          originLocation: null,
          destinationLocation: null,
          woodLoose: null,
          containerType: null,
          minimumRate: false,
          journeyDistance: null,
          transitTime: null,
          lineRate: null,
          minimum: null,
          maximumCharge: null,
          maximumRate: null,
          minimumBreakpoint: null,
          maximumBreakpoint: null,
          minimumDistance: null,
          maximumDistance: null,
          onCarriageLocation: null,
          onCarriageRate: null,
          preCarriageLocation: null,
          preCarriageRate: null,
          calculatedMinimum: null,
          calculatedMaximum: null,
          routingInfo: null,
          placeOfReceipt: null,
          placeOfDelivery: null,
          portOfDischarge: null,
          portOfLoading: null
        },
        leaveAsIs: [ 'id', 'transitTime', 'lineRate', 'minimum', 'maximumCharge', 'minimumBreakpoint', 'maximumBreakpoint', 'minimumDistance', 'maximumDistance', 'onCarriageRate', 'preCarriageRate' ],
        formStringFromLocation: [ 'originLocation', 'destinationLocation', 'preCarriageLocation', 'onCarriageLocation' ],
        formStringOption: [ 'containerType', 'woodLoose' ]
      }
    },
    computed: {
      detailsToSpreadsheet () {
        return this.dataForSpreadSheet.map(obj => {
          let o = {}
          for (let prop in obj) {
            if (this.formStringFromLocation.includes(prop) && typeof obj[prop] === 'object' && obj[prop] !== null && obj[prop].hasOwnProperty('id')) {
              o[prop] = this.displayLocation(obj[prop])
            } else if (this.formStringOption.includes(prop) && obj[prop]) {
              o[prop] = this.getOptionName(obj[prop])
            } else if (this.leaveAsIs.includes(prop)) {
              o[prop] = obj[prop]
            }
          }
          return o
        })
      },
      fileName () {
        return `tariff-${this.lookup}-details`
      },
      financialCodes () {
        return this.$store.getters['systemOption/financialCodes']
      },
      containers () {
        return this.sortedOptions('CONTAINER_TYPE')
      },
      woodLooses () {
        return this.sortedOptions('WOOD_LOOSE')
      },
      ratesPer () {
        return this.sortedOptions('BREAKPOINT_UNIT')
      },
      saveOrUpdate () {
        return this.entity.id !== null ? 'Update' : 'Save'
      },
      saveUrl () {
        return this.entity.id ? API.UPDATE_ADMIN_ENTITY('lookup-detail', this.entity.id) : API.CREATE_ADMIN_ENTITY('lookup-detail')
      },
      saveMethod () {
        return this.entity.id ? 'put' : 'post'
      },
      isUpdate () {
        return this.entity.id !== null
      },
      requestBody () {
        return this.isUpdate ? this.transformedEntity : this.nullifyEntity
      }
    },
    watch: {
      details: {
        deep: true,
        handler: function (newVal, oldVal) {
          this.$emit('updating', newVal)
          this.dataForSpreadSheet = newVal
        }
      },
      dets: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (JSON.stringify(newVal) !== JSON.stringify(this.details)) {
            this.details = newVal
          }
        }
      }
    },
    methods: {
      successFn (data) {
        this.$emit('update-details-upload', data)
        event.$emit('toast', { type: 'success', message: 'Lines calculated values updated' })
      },
      doCalc () {
        this.doCalculations(this.lookup)
        .then(res => this.successFn(res)).catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'error', message: 'Unable to update calculated line values; please try again or contact support' })
        })
      },
      deleteAll (items) {
        let count = items.length
        if (count > 0) {
          let n = 0
          event.$emit('loading-on', { title: 'Deleting items' })
          items.filter(({id}) => id).forEach(({id}) => {
            this.$http.delete(API.DELETE_ADMIN_ENTITY('lookup-detail', id))
            .then(res => { /* No Op */ })
            .catch(err => {
              console.log(err)
              event.$emit('toast', { type: 'error', message: 'An error occured deleting tariff with id ' + id })
            }).then(() => {
              if (++n === count) {
                event.$emit('loading-off')
                event.$emit('toast', { type: 'success', message: 'Complete' })
                this.$emit('get-details')
              }
            })
          })
        }
      },
      getNewData (data) {
        this.dataForSpreadSheet = data
      },
      parsing () {
        event.$emit('loading-on', { title: 'Parsing tariff line upload' })
      },
      parsed (file) {
        this.multiSave(file)
      },
      multiSave ({data}) {
        event.$emit('loading-on', { title: 'Uploading' })
        this.$http.post(API.BATCH_CREATE_ADMIN_ENTITY('lookup-detail'), data.map(obj => {
          let o = {}
          for (let prop in obj) {
            if (this.leaveAsIs.includes(prop)) {
              o[prop] = obj[prop]
            }
          }
          return o
        }))
        .then(({data}) => {
          if (this.entity.id) {
            this.doClear()
          }
          this.$emit('update-details-upload', data)
          event.$emit('toast', { type: 'success', message: 'All rows successfully updated' })
          this.doCalc()
        }).catch(err => {
          console.log(err)
          event.$emit('toast', { type: 'warning', message: 'An error occured uploading some rows; please check your document for correct layout' })
        }).then(() => {
          event.$emit('loading-off', {})
        })
      },
      getOptionName (id) {
        let dO = this.getSystemOption(id)
        return dO ? dO.name : ''
      },
      deCamel (string) {
        if (string === 'maximumRate') {
          return 'Maximum Charge'
        } else if (string === 'minimum') {
          return 'Minimum Charge'
        }
        return string.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
      },
      selectLocation (location, prop) {
        this.locationSearchText = ''
        this.locationSearchResults = []
        this.entity[prop] = location
      },
      doDelete ({ item, index }) {
        this.$http.delete(API.DELETE_ADMIN_ENTITY('lookup-detail', item.id))
        .then(res => {
          let i = this.details.findIndex(({id}) => id === item.id)
          if (i > -1) {
            this.details.splice(i, 1)
          }
          event.$emit('toast', { type: 'success', message: 'Tariff Line Deleted' })
          this.doClear()
        }).catch(err => {
          event.$emit('toast', { type: 'error', message: err.message })
          console.log(err)
        })
      },
      save () {
        if (!this.updateClicked) {
          this.init = false
          this.updateClicked = true
          this.entity.lookup = this.lookup
          let msg = this.isUpdate ? 'Tariff Line Updated' : 'Line Added to Tariff'
          let copy = { ...this.requestBody }
          delete copy.calculatedMaximum
          delete copy.calculatedMinimum
          this.$http[this.saveMethod](this.saveUrl, copy)
          .then(({data}) => {
            if (data.hasOwnProperty('id')) {
              this.updateClicked = false
              this.entity.id = data.id
              this.addToList({ ...this.entity, selected: false })
              event.$emit('toast', { type: 'success', message: msg })
            }
            this.doCalc()
          }).catch(err => {
            this.updateClicked = false
            event.$emit('toast', { type: 'error', message: err.message })
            console.log(err)
          }).then(() => {
            this.init = true
          })
        }
      },
      addToList (de) {
        let i = this.details.findIndex(d => d.id === de.id)
        if (i === -1) {
          this.details.push(de)
        } else {
          for (let prop in de) {
            this.details[i][prop] = de[prop]
          }
        }
        this.doClear()
      },
      doClear () {
        this.init = false
        this.$nextTick(() => {
          let item = {
            id: null,
            lookup: null,
            originLocation: null,
            destinationLocation: null,
            woodLoose: null,
            containerType: null,
            minimumRate: false,
            maximumCharge: null,
            maximumRate: null,
            journeyDistance: null,
            transitTime: null,
            lineRate: null,
            minimum: null,
            minimumBreakpoint: null,
            maximumBreakpoint: null,
            minimumDistance: null,
            maximumDistance: null,
            onCarriageLocation: null,
            onCarriageRate: null,
            preCarriageLocation: null,
            preCarriageRate: null,
            calculatedMinimum: null,
            calculatedMaximum: null,
            routingInfo: null,
            placeOfReceipt: null,
            placeOfDelivery: null,
            portOfDischarge: null,
            portOfLoading: null
          }
          this.updateActive({ item, index: null })
          this.init = true
        })
      },
      updateActive ({ item, index }) {
        for (let prop in item) {
          this.entity[prop] = item[prop]
        }
      },
      sortedOptions (type) {
        return this.getSystemOptions(type).sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Tariff/TariffDetails.vue